export default __webpack_public_path__ + "img-upload-placeholder.png";